export enum RefundRequestStatus {
  PUBLISHER_REVIEWING = 'publisher_reviewing',
  ADMIN_REVIEWING = 'admin_reviewing',
  PUBLISHER_APPROVED = 'publisher_approved',
  PUBLISHER_REJECTED = 'publisher_rejected',
  ADMIN_APPROVED = 'admin_approved',
  ADMIN_REJECTED = 'admin_rejected',
  REJECTED = 'rejected',
}
